import $ from "npm:jquery";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
interface Window {
  // for snippet_py
  _current_output_dom: HTMLElement;
  // for snippet_js
  println: (s: string) => void;
  snippet_stdout: HTMLElement;
}

import { initialize_light } from "./darkmode.ts";
import { link_hashtags } from "./hashtag.ts";
import { transform_snippet_dom } from "./snippet.ts";
import { activate_py_snippet } from "./snippet_py.ts";

async function setup_snippets() {
  transform_snippet_dom();
  activate_py_snippet();
}

$(function () {
  initialize_light();
  if (window.location.href.search("/gollum/edit/") < 0) {
    link_hashtags();
    setup_snippets();
  }
  if ("ace" in window) {
    // https://stackoverflow.com/questions/10883190/ace-editor-define-is-not-defined
    window.define = ace.define;
    window.require = ace.require;
    const is_dark_mode: boolean = $("html").data("dark-mode") ?? false;
    if (is_dark_mode) {
      const theme = "monokai";
      ace.config.setModuleUrl(
          "ace/theme/" + theme,
          "https://cdnjs.cloudflare.com/ajax/libs/ace/" + ace.version + "/theme-" + theme + ".min.js"
      )
      var editor = ace.edit("gollum-editor-body-ace");
      editor.setTheme("ace/theme/" + theme);
    }
  }
});
